
  <main  id='recorder' [ngStyle]="storeFillLightStyle" [class.fill-light-active]="recorderStore.fillLight().brightness > 0">
    <main id='loading' *ngIf='!loaded'>
      <article id='singsnapContainer' style='padding-right: 2.5rem; display: flex; flex-direction: row; align-items: center; justify-content: center;'>
        <img src='../../assets/images/recorderlogo.png'> <h2>SINGSNAP</h2>
      </article>
      <div class="vl"></div>
      <h2 class="recording-loading" >Loading... <i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 47px; text-shadow: none;"></i></h2>

  </main>

      <!-- HEADER: back button + title on left, Remixer pill in center -->
      <header class="remix-header" *ngIf="loaded">
        <div class="rec-header">
          <div class="rec-header__inner">
            <div class="rec-header__left">
              <button class="rec-back-btn" *ngIf="!finished" (click)="backClicked()" aria-label="Back" ssTooltip="Leave the remixer and go back">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
              </button>
              <div class="rec-header__meta">
                <h2 class="rec-header__title">{{ remix.song?.title }}</h2>
              </div>
            </div>
            <div class="rec-header__center">
              <div class="remix-pill-group">
                <span class="remix-pill is-active">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="4" y1="21" x2="4" y2="14"/>
                    <line x1="4" y1="10" x2="4" y2="3"/>
                    <line x1="12" y1="21" x2="12" y2="12"/>
                    <line x1="12" y1="8" x2="12" y2="3"/>
                    <line x1="20" y1="21" x2="20" y2="16"/>
                    <line x1="20" y1="12" x2="20" y2="3"/>
                    <line x1="1" y1="14" x2="7" y2="14"/>
                    <line x1="9" y1="8" x2="15" y2="8"/>
                    <line x1="17" y1="16" x2="23" y2="16"/>
                  </svg>
                  Remixer
                </span>
              </div>
            </div>
            <div class="rec-header__right"></div>
          </div>
        </div>
      </header>

      <!-- LEFT: Mix panel (Mix + Timing sections) -->
      <aside class="remix-aside" *ngIf="loaded">
        <div class="panel">
          <div class="panel__header panel__header--static">
            <span class="panel__title">Remix</span>
            <span class="panel__status panel__status--review">
              <span class="panel__status-dot panel__status-dot--review"></span> Mixing
            </span>
          </div>
          <div class="panel__body">

            <!-- MIX section -->
            <div class="section">
              <h3 class="section__header"><span class="section__label">Mix</span></h3>
              <div class="section__body">

                <!-- Vocal Volume -->
                <div class="perf-slider" ssTooltip="Adjust the volume of your recorded voice">
                  <div class="perf-slider__header">
                    <span class="perf-slider__label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                      Vocal Volume
                    </span>
                    <span
                      *ngIf="editingPill !== 'vocal'"
                      class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                      role="button"
                      tabindex="0"
                      ssTooltip="Click to enter an exact value (0–100)"
                      (click)="startPillEdit('vocal', micVolumeDisplay)"
                      (keydown.enter)="startPillEdit('vocal', micVolumeDisplay)">{{ micVolumeDisplay }}</span>
                    <input
                      *ngIf="editingPill === 'vocal'"
                      #pillInput
                      type="number"
                      class="perf-slider__current perf-slider__current--input"
                      min="0" max="100" step="1"
                      aria-label="Vocal volume (0 to 100)"
                      [value]="pillDraft"
                      (blur)="commitPillEdit('vocal', $any($event.target).value, 0, 100)"
                      (keydown.enter)="commitPillEdit('vocal', $any($event.target).value, 0, 100)"
                      (keydown.escape)="cancelPillEdit()"
                    />
                  </div>
                  <input
                    type="range"
                    class="perf-slider__track"
                    min="0" max="2" step="0.02"
                    aria-label="Vocal volume"
                    [value]="micVolume"
                    [style.background]="sliderBg(micVolume, 0, 2)"
                    (input)="onMicVolumeSliderChange(+$any($event.target).value)"
                  />
                  <div class="perf-slider__marks">
                    <span>0</span><span>50</span><span>100</span>
                  </div>
                </div>

                <!-- Music Volume -->
                <div class="perf-slider" ssTooltip="Adjust the backing track volume">
                  <div class="perf-slider__header">
                    <span class="perf-slider__label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
                      Music Volume
                    </span>
                    <span
                      *ngIf="editingPill !== 'music'"
                      class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                      role="button"
                      tabindex="0"
                      ssTooltip="Click to enter an exact value (0–100)"
                      (click)="startPillEdit('music', musicVolumeDisplay)"
                      (keydown.enter)="startPillEdit('music', musicVolumeDisplay)">{{ musicVolumeDisplay }}</span>
                    <input
                      *ngIf="editingPill === 'music'"
                      #pillInput
                      type="number"
                      class="perf-slider__current perf-slider__current--input"
                      min="0" max="100" step="1"
                      aria-label="Music volume (0 to 100)"
                      [value]="pillDraft"
                      (blur)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                      (keydown.enter)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                      (keydown.escape)="cancelPillEdit()"
                    />
                  </div>
                  <input
                    type="range"
                    class="perf-slider__track"
                    min="0" max="2" step="0.02"
                    aria-label="Music volume"
                    [value]="musicVolume"
                    [style.background]="sliderBg(musicVolume, 0, 2)"
                    (input)="onMusicVolumeSliderChange(+$any($event.target).value)"
                  />
                  <div class="perf-slider__marks">
                    <span>0</span><span>50</span><span>100</span>
                  </div>
                </div>

                <!-- MMSB toggle -->
                <button
                  *ngIf="UI.mmsbButton"
                  type="button"
                  class="mmsb-toggle"
                  [class.is-on]="mmsb"
                  [attr.aria-pressed]="mmsb"
                  ssTooltip="Make Me Sound Better — enhances your voice in the mix"
                  (click)="mmsb = !mmsb; onChangeMMSB()"
                >
                  <span class="mmsb-toggle__icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M9 18V5l12-2v13"/>
                      <circle cx="6" cy="18" r="3"/>
                      <circle cx="18" cy="16" r="3"/>
                    </svg>
                  </span>
                  <span class="mmsb-toggle__text">Make Me Sound Better</span>
                  <span class="mmsb-toggle__badge" [class.is-on]="mmsb">{{ mmsb ? 'ON' : 'OFF' }}</span>
                </button>

              </div>
            </div>

            <!-- TIMING section -->
            <div class="section" *ngIf="UI.syncButton">
              <h3 class="section__header"><span class="section__label">Timing</span></h3>
              <div class="section__body">

                <!-- Sync slider -->
                <div class="perf-slider" ssTooltip="Adjust the timing between your voice and the music">
                  <div class="perf-slider__header">
                    <span class="perf-slider__label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                      Sync
                    </span>
                    <span
                      *ngIf="!syncEditing"
                      class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                      role="button"
                      tabindex="0"
                      ssTooltip="Click to enter an exact sync value"
                      (click)="startSyncEdit()"
                      (keydown.enter)="startSyncEdit()">{{ sync }} ms</span>
                    <input
                      *ngIf="syncEditing"
                      #syncInput
                      type="number"
                      class="perf-slider__current perf-slider__current--input"
                      min="-500" max="500" step="1"
                      aria-label="Sync value in milliseconds"
                      [value]="syncDraft"
                      (blur)="commitSyncEdit($any($event.target).value)"
                      (keydown.enter)="commitSyncEdit($any($event.target).value)"
                      (keydown.escape)="cancelSyncEdit()"
                    />
                  </div>
                  <div class="sync-nudge">
                    <button
                      type="button"
                      class="sync-nudge__btn"
                      aria-label="Nudge sync earlier"
                      ssTooltip="−1 ms (hold to repeat by 5)"
                      (pointerdown)="startSyncNudge(-1)"
                      (pointerup)="stopSyncNudge()"
                      (pointerleave)="stopSyncNudge()"
                      (pointercancel)="stopSyncNudge()"
                      (keydown.enter)="nudgeSync(-1); $event.preventDefault()">−</button>
                    <input
                      type="range"
                      class="perf-slider__track"
                      min="-500" max="500" step="10"
                      aria-label="Sync offset in milliseconds"
                      [value]="sync"
                      [style.background]="sliderBg(sync, -500, 500)"
                      (input)="onSyncSliderInput(+$any($event.target).value)"
                      (change)="onSyncSliderChange(+$any($event.target).value)"
                    />
                    <button
                      type="button"
                      class="sync-nudge__btn"
                      aria-label="Nudge sync later"
                      ssTooltip="+1 ms (hold to repeat by 5)"
                      (pointerdown)="startSyncNudge(1)"
                      (pointerup)="stopSyncNudge()"
                      (pointerleave)="stopSyncNudge()"
                      (pointercancel)="stopSyncNudge()"
                      (keydown.enter)="nudgeSync(1); $event.preventDefault()">+</button>
                  </div>
                  <div class="perf-slider__marks">
                    <span>-500ms</span><span>0ms</span><span>500ms</span>
                  </div>
                </div>

              </div>
            </div>

          </div><!-- /panel__body -->
        </div><!-- /panel -->
      </aside>

      <!-- RIGHT: Lighting + Lyrics panel -->
      <aside class="remix-aside remix-aside--right" *ngIf="loaded">
        <div class="panel">
          <div class="panel__header panel__header--static">
            <span class="panel__title">Visual</span>
          </div>
          <div class="panel__body">

            <!-- LIGHTING section -->
            <div class="section">
              <h3 class="section__header"><span class="section__label">Screen Lighting</span></h3>
              <div class="section__body">
                <rec-fill-light show="brightness" (userBrightnessChange)="detectChanges()"></rec-fill-light>
              </div>
            </div>

            <!-- LYRICS section -->
            <div class="section">
              <h3 class="section__header"><span class="section__label">Lyrics</span></h3>
              <div class="section__body">

                <!-- Lyrics On/Off toggle -->
                <button
                  type="button"
                  class="mmsb-toggle"
                  [class.is-on]="lyricsVisible"
                  [attr.aria-pressed]="lyricsVisible"
                  ssTooltip="Show or hide the karaoke lyrics during playback"
                  (click)="toggleLyrics()"
                >
                  <span class="mmsb-toggle__icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                      <line x1="8" y1="13" x2="16" y2="13"/>
                      <line x1="8" y1="17" x2="13" y2="17"/>
                    </svg>
                  </span>
                  <span class="mmsb-toggle__text">Lyrics</span>
                  <span class="mmsb-toggle__badge" [class.is-on]="lyricsVisible">{{ lyricsVisible ? 'ON' : 'OFF' }}</span>
                </button>

              </div>
            </div>

          </div>
        </div>
      </aside>

      <main id='recorderContainer'>

          <section id='videoSection'>
            <main #errorMessageContainer style='display: none; color: red;' class='countdown'>
              <h3  #errorMessage ></h3>
            </main>
              <div id='lyrics-container' [hidden]="!lyricsVisible">
                <div id='grave' class='hidden'></div>
                <main id='lines-container'>
                    <div id='the-grave' class='lyrics'></div>
                    <div id='swipe' class='lyrics'></div>
                    <div id='next-up' class='lyrics'></div>
                    <div id='initial' class='lyrics'></div>
                    <div id='the-womb' class='lyrics'></div>
                </main>
                <div id='womb' class='hidden'></div>
            </div>
              <div id='videoContainer' [class.is-duet]="jam">
                <div id='actualVideoContainer' [class.is-duet]="jam">
                  <video #recVideo
                  id="videoRecorder"
                  autoplay="true"
                  style='
                    background-image: url(../../assets/images/audio_only.png);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                    height: 68vh;
                    width: 68vh;'
                  ></video>
                  <video #duetVideo style='display: none; height: 68vh; width: 68vh; background-image: url(../../assets/images/audio_only.png); background-position: center; background-repeat: no-repeat; background-size: contain;'
                  id="duetVideo"
                  autoplay="false"
                  ></video>
                  </div>

                <!-- Scrub bar overlay (positioned inside the video frame, recorder pattern) -->
                <div class="video-scrubbar" *ngIf="loaded">
                  <span class="video-scrubbar__time">{{ msToTime(playhead) }}</span>
                  <app-progress-bar
                    class="video-scrubbar__bar"
                    [recorder]="true"
                    [duration]="duration"
                    [current]="playhead"
                    (seek)="seek($event)"
                    (range)="changeRangeTime($event)"
                  ></app-progress-bar>
                  <span class="video-scrubbar__duration">{{ msToTime(duration) }}</span>
                </div>
              </div>

              <!-- FOOTER: stage-action buttons (Play/Pause + Save) like the recorder -->
              <footer class="remix-footer" *ngIf="loaded">
                <div class="stage-actions stage-actions--review">
                  <button
                    *ngIf="UI.pauseButton"
                    type="button"
                    class="stage-btn stage-btn--play"
                    ssTooltip="Pause playback of your remix"
                    (click)="pause()"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                    PAUSE
                  </button>
                  <button
                    *ngIf="UI.resumePracticeButton"
                    type="button"
                    class="stage-btn stage-btn--play"
                    ssTooltip="Play your remix with the current mix and timing"
                    (click)="play()"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                    PLAY
                  </button>
                  <button
                    *ngIf="UI.saveOrTryAgainButtons"
                    type="button"
                    class="stage-btn stage-btn--save"
                    ssTooltip="Save this remix"
                    (click)="upload()"
                  >
                    SAVE
                  </button>
                </div>
              </footer>
          </section>

      </main>

  </main>
